// cat. into common modules
import {stringToNumber} from "@into/into-common-utils";

// cat. config
import {
    CONFIG_SYSTEM_KEYS,
    CONFIG_SYSTEM_NUMBER_KEYS
} from "config/configs/system";

/**
 * configValue를 적절한 타입으로 변환
 * @param {string} configKey - 설정 키
 * @param {string} configValue - 설정 값
 * @returns {boolean|number|string} 변환된 값
 */
function parseConfigValue(configKey, configValue) {
    // Boolean 타입 변환
    if (configValue === "true" || configValue === "TRUE") {
        return true;
    }
    if (configValue === "false" || configValue === "FALSE") {
        return false;
    }

    // Number 타입 변환
    if (CONFIG_SYSTEM_NUMBER_KEYS.includes(configKey)) {
        return stringToNumber(configValue);
    }

    // 그 외는 문자열로 반환
    return configValue;
}

/**
 * 시스템 설정 목록을 파싱하여 설정 객체로 변환
 * @param {Array} configList - 백엔드에서 받은 설정 목록 [{configKey, configValue}, ...]
 * @returns {Object} 파싱된 설정 객체
 */
function parseConfigList(configList) {
    if (!configList || configList.length === 0) {
        return {};
    }

    const configs = {};

    configList.forEach((item) => {
        const configKey = item['systemConfig.configKey'];
        const configValue = item['systemConfig.configValue'];

        // 정의된 키만 처리
        if (CONFIG_SYSTEM_KEYS.includes(configKey)) {
            configs[configKey] = parseConfigValue(configKey, configValue);
        }
    });

    return configs;
}

/**
 * 시스템 설정 목록을 파싱하여 SYSTEM 설정 객체로 변환
 *
 * @param {Array} systemConfigList - 백엔드에서 받은 설정 목록 [{configKey, configValue}, ...]
 * @param {Object} initialSystemConfig - 초기 SYSTEM 설정값
 * @returns {Object} 파싱된 SYSTEM 설정 객체
 */
export function parseSystemConfig(systemConfigList, initialSystemConfig) {
    if (!systemConfigList || systemConfigList.length === 0) {
        return initialSystemConfig;
    }

    // 설정 리스트 파싱
    const configs = parseConfigList(systemConfigList);

    // 초기값과 병합하여 반환
    return {
        ...initialSystemConfig,
        ...configs
    };
}